<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
// import { ModelListSelect } from "vue-search-select";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Bursary Categories",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
  },
  data() {
    return {
      title: "Bursary Categories",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "type_field",
          label: "Type",
          sortable: true,
        },
        {
          key: "amount_field",
          label: "Amount",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          key: "date",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        amount: "",
        type: 0,
        description: "",
        recAccount: "",
        expAccount: "",
      },
      deletedata: {
        name: "",
        class: "",
        id: "",
      },
      editdata: {
        name: "",
        type: "",
        amount: "",
        description: "",
        // recAccount: "",
        // expAccount: "",
        id: "",
      },
      nameError: "",
      typeError: "",
      amountError: "",
      modal: "",
      types: [
        { id: 1, name: "Full Bursary" },
        { id: 2, name: "Half Bursary" },
        { id: 3, name: "Custom Amount" },
      ],
      pageError: {
        nameError: "",
        expAccountError: "",
        recAccountError: "",
      },
    };
  },
  computed: {
    ...mapGetters("fees", ["BursaryCategories", "SaveStatus"]),
    ...mapGetters("accounts", ["getMappAccounts", "getMappedAccounts"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.BursaryCategories ? this.BursaryCategories.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.BursaryCategories ? this.BursaryCategories.length : 1;
  },
  methods: {
    ...mapActions({
      FetchBursaryCategories: "fees/fetchBursaryCategories",
      AddCategory: "fees/addBursaryCategory",
      EditCategory: "fees/editBursaryCategory",
      DeleteCategory: "fees/deleteBursaryCategory",
      FetchMappAccounts: "accounts/fetchMappAccounts",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.BursaryCategories
        ? this.BursaryCategories.length
        : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },

    resetError() {
      this.nameError = "";
      this.amountError = "";
      this.typeError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.description = "";
      this.data.amount = "";
      this.data.type = 0;
      this.data.recAccount = "";
      this.data.expAccount = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.type = 0;
      this.editdata.description = "";
      this.editdata.amount = "";
      this.editdata.id = "";
      this.editdata.recAccount = "";
      this.editdata.expAccount = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    addCategory(modal) {
      this.modal = modal;
      this.AddCategory(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.type = values.item.type;
      this.editdata.amount = this.thousandSeperater(values.item.amount);
      this.editdata.description = values.item.description;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteCategory(modal) {
      this.modal = modal;
      this.DeleteCategory(this.deletedata);
      this.closeModal(modal);
    },
    editCategory(modal) {
      this.modal = modal;
      this.EditCategory(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchBursaryCategories();
    this.FetchMappAccounts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_bursary_categories')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title text-primary">Fees Bursary Categories</h3>
              </div>
              <div class="col-md-3">
                <button
                  v-b-modal.add-setting-modal
                  class="btn btn-primary float-end btn-sm"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_bursary_categories')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add Category
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="BursaryCategories ? BursaryCategories : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(type_field)="data">
                  <span v-if="data.item.type == 1">Full Bursary</span>
                  <span v-if="data.item.type == 2">Half Bursary</span>
                  <span v-if="data.item.type == 3">Custom Bursary</span>
                </template>
                <template #cell(amount_field)="data">
                  <span v-if="data.item.type == 3">{{
                    data ? thousandSeperater(data.item.amount) : "---"
                  }}</span>
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <button
                      class="btn btn-outline-primary btn-sm"
                      v-b-modal.edit-setting-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_bursary_categories')
                        )
                      "
                    >
                      <i class="fa fa-edit"></i> Edit
                    </button>
                    <button
                      class="btn btn-outline-danger btn-sm"
                      v-b-modal.delete-setting-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_bursary_categories')
                        )
                      "
                    >
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-setting-modal"
        class="modal-lg"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_bursary_categories')
          )
        "
      >
        <template #modal-title> Set New Bursary Category</template>
        <form @submit.prevent="addCategory" class="m-2">
          <div class="row">
            <div class="form-group col-md-6 mb-2">
              <label>Category Name <span class="required">*</span></label>
              <div class="input-group">
                <input
                  type="text"
                  required
                  placeholder="Bursary Category Name"
                  class="form-control"
                  @input="resetError()"
                  v-model="data.name"
                />
              </div>
              <div class="text-danger" v-if="nameError">
                <em>{{ nameError }}</em>
              </div>
              <small class="text-primary">Example: Academics Bursary</small>
            </div>
            <div class="form-group col-md-6 mb-2">
              <label>Type <span class="required">*</span></label>
              <div class="input-group">
                <select
                  required
                  class="form-control"
                  v-model="data.type"
                  @input="resetError()"
                >
                  <option value="0">Select Category Type</option>
                  <option
                    v-for="(t, index) in types"
                    :key="index"
                    :value="t.id"
                  >
                    {{ t.name }}
                  </option>
                </select>
              </div>
              <div class="text-danger" v-if="typeError">
                <em>{{ typeError }}</em>
              </div>
            </div>
            <div class="form-group col-md-6 mb-2" v-if="data.type == '3'">
              <label>Amount <span class="required">*</span></label>
              <div class="input-group">
                <input
                  type="text"
                  required
                  placeholder="Fee Amount"
                  class="form-control"
                  @input="resetError(), addCommas()"
                  v-model="data.amount"
                />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
            </div>
            <!-- <div class="form-group mb-2 col-md-6">
              <label>Receive to Account <span class="required">*</span></label>
              <model-list-select
                required
                :list="getMappAccounts ? getMappAccounts : []"
                v-model="data.recAccount"
                option-value="id"
                option-text="acc_name"
                class="mb-2"
                placeholder="Select Account"
                @input="checkError"
              >
              </model-list-select>
              <span
                class="text-danger"
                v-if="pageError.recAccountError !== ''"
                >{{ pageError.recAccountError }}</span
              >
            </div> -->
            <!-- <div class="form-group mb-2 col-md-6">
              <label>Expense to Account <span class="required">*</span></label>
              <model-list-select
                required
                :list="getMappAccounts ? getMappAccounts : []"
                v-model="data.expAccount"
                option-value="id"
                option-text="acc_name"
                class="mb-2"
                placeholder="Select Account"
                @input="checkError"
              >
              </model-list-select>
              <span
                class="text-danger"
                v-if="pageError.expAccountError !== ''"
                >{{ pageError.expAccountError }}</span
              >
            </div> -->
            <div class="form-group col-md-12 mb-2">
              <label>Description <small>(Optional)</small></label>
              <div class="input-group">
                <textarea
                  class="form-control"
                  v-model="data.description"
                  placeholder="Category Description"
                ></textarea>
              </div>
              <small class="text-primary"
                >Example: Bursary For those who perform well in class</small
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger btn-sm"
              data-dismiss="modal"
              @click="closeModal('add-setting-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button type="submit" class="btn btn-outline-primary btn-sm">
              <i class="fa fa-check"></i>
              Submit
              <b-spinner
                v-if="SaveStatus"
                variant="light"
                small
                label="Spinning"
              ></b-spinner>
            </button>
          </div>
        </form>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-setting-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_bursary_categories')
          )
        "
      >
        <template #modal-title>
          Edit Bursary Category {{ editdata.name }}</template
        >
        <div class="form-group mb-2">
          <label>Category Name <span class="required">*</span></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Bursary Category Name"
              class="form-control"
              @input="resetError()"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
          <small class="text-primary">Example: Academics Bursary</small>
        </div>
        <div class="form-group mb-2">
          <label>Type <span class="required">*</span></label>
          <div class="input-group">
            <select
              class="form-control"
              v-model="editdata.type"
              @input="resetError()"
            >
              <option value="0">Select Category Type</option>
              <option v-for="(t, index) in types" :key="index" :value="t.id">
                {{ t.name }}
              </option>
            </select>
          </div>
          <div class="text-danger" v-if="typeError">
            <em>{{ typeError }}</em>
          </div>
        </div>
        <div class="form-group mb-2" v-if="editdata.type == '3'">
          <label>Amount <span class="required">*</span></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Fee Amount"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="editdata.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Description <small>(Optional)</small></label>
          <div class="input-group">
            <textarea
              class="form-control"
              v-model="editdata.description"
              placeholder="Category Description"
            ></textarea>
          </div>
          <small class="text-primary"
            >Example: Bursary For those who perform well in class</small
          >
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            data-dismiss="modal"
            @click="closeModal('edit-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="editCategory('edit-setting-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete setting starts -->
      <b-modal
        id="delete-setting-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_bursary_categories')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete {{ deletedata.name }} From {{ deletedata.class }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete {{ deletedata.name }} From
              {{ deletedata.class }}? Click Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            data-dismiss="modal"
            @click="closeModal('delete-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            @click="deleteCategory('delete-setting-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.required {
  color: red;
}
</style>
